import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query';

import { env } from '@/config/env';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { getStorageItem } from '@/utils/localStorage.util';

const prepareHeaders = (headers: Headers) => {
  const jwt = getStorageItem<string>(StorageKeysEnum.jwt);

  if (jwt) {
    headers.set('authorization', `Bearer ${jwt}`);
  }
  if (env.TENANT) {
    headers.set('X-TENANT-ID', env.TENANT);
  }

  return headers;
};

export const baseQuery = fetchBaseQuery({
  baseUrl: env.API_BASE_URL,
  prepareHeaders,
});

export const baseQueryWithRedirect: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const lang = getStorageItem<string>(StorageKeysEnum.i18nextLng);
  const result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    localStorage.clear();
    window.location.href = `${env.GAMEZONE_URL}?lang=${lang}`;
  }
  return result;
};
